// src/app/modules/Dashboard/components/DashboardLoader.jsx
import React from 'react';
import { Shield, Brain, TrendingUp } from 'lucide-react';
import './DashboardLoader.scss';

export function DashboardLoader() {
  return (
    <div className="dashboard-loader">
      <div className="loader-content">
        <div className="loader-icons">
          <div className="loader-icon icon-1">
            <Shield size={32} />
          </div>
          <div className="loader-icon icon-2">
            <Brain size={32} />
          </div>
          <div className="loader-icon icon-3">
            <TrendingUp size={32} />
          </div>
        </div>
        <h3>Analyzing Security Data</h3>
        <p>Generating your intelligence dashboard...</p>
        <div className="loader-bar">
          <div className="loader-progress"></div>
        </div>
      </div>
    </div>
  );
}